import { AxiosResponse } from "axios";

import {
  IAddAiPromptTemplateRequest,
  IAiPromptTemplate,
  IAiPromptTemplateListItem,
  IUpdateAiPromptTemplateRequest,
} from "../../@types/admin/AdminAiPromptTemplate";
import { IPaginatedResponse } from "../../@types/PaginatedResponse";
import { api } from "../api";

/**
 * AI prompt templates admin page (EN-5161), migrated from the Retool
 * AIPromptTemplates app. The list endpoint takes optional filters and
 * pagination; both are omitted so the whole set comes back for client-side
 * search, as Retool's table did.
 */
export const aiPromptTemplatesService = {
  async getAiPromptTemplates(): Promise<
    AxiosResponse<IPaginatedResponse<IAiPromptTemplateListItem[]>>
  > {
    return api.get<IPaginatedResponse<IAiPromptTemplateListItem[]>>(
      "/Retool/AiPromptTemplates"
    );
  },

  /** One template including its body — the list rows don't carry it. */
  async getAiPromptTemplateById(
    id: string
  ): Promise<AxiosResponse<IAiPromptTemplate>> {
    return api.get<IAiPromptTemplate>(`/Retool/AiPromptTemplates/${id}`);
  },

  async addAiPromptTemplate(
    request: IAddAiPromptTemplateRequest
  ): Promise<AxiosResponse<void>> {
    return api.post<void>("/Retool/AiPromptTemplates", request);
  },

  async updateAiPromptTemplate(
    request: IUpdateAiPromptTemplateRequest
  ): Promise<AxiosResponse<void>> {
    return api.put<void>(`/Retool/AiPromptTemplates/${request.id}`, request);
  },
};
